import { useSyncExternalStore } from 'react'

// TOASTS (owner, 2026-10-07: "a toast message when it's done"). A short message in the corner that says what landed and where,
// goes by itself after a while, and never blocks anything. One store outside React, so a reply that lands after the rep has
// left the page still says so.

export interface Toast { id: number; title: string; body?: string; href?: string; kind: 'done' | 'error' | 'reminder'; at: number }

export const TOAST_MS = 9000
let next = 1
let toasts: readonly Toast[] = []
const listeners = new Set<() => void>()
const timers = new Map<number, ReturnType<typeof setTimeout>>()

function set(list: readonly Toast[]) { toasts = list; for (const l of listeners) l() }

export function toast(t: { title: string; body?: string; href?: string; kind?: Toast['kind'] }, ttlMs = TOAST_MS): number {
  const id = next++
  set([...toasts, { id, title: t.title, body: t.body, href: t.href, kind: t.kind ?? 'done', at: Date.now() }].slice(-5))
  if (ttlMs > 0) timers.set(id, setTimeout(() => dismiss(id), ttlMs))
  return id
}

export function dismiss(id: number) {
  const timer = timers.get(id)
  if (timer) { clearTimeout(timer); timers.delete(id) }
  if (toasts.some((t) => t.id === id)) set(toasts.filter((t) => t.id !== id))
}

export function clearToasts() { for (const id of [...timers.keys()]) dismiss(id); set([]) }

function subscribe(l: () => void) { listeners.add(l); return () => { listeners.delete(l) } }

export function useToasts(): readonly Toast[] {
  return useSyncExternalStore(subscribe, () => toasts, () => toasts)
}

/** For tests and the menu: what is showing now. */
export function currentToasts(): readonly Toast[] { return toasts }
